import React from 'react';
import Q from 'js/quantum';
import Global from 'global';
import { Pagination2 } from 'js/widgets/pagination';
import { setCurrentNav } from './common';
import {NavItem, setNavBar} from "../nav";

export class OpLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            query: {},
            pagedResult: Pagination2.getInitialPagedResult(),
        };
    }

    componentDidMount() {
        const navItems = [new NavItem('操作记录', '/op_logs')];
        setNavBar(navItems, '操作记录');
        this.refresh(this.state.query);
    }

    async refresh(query) {
        let data = null;
        if (this.props.uid) {
            data = await Q.get(`/api/user/${this.props.uid}/op_logs`, { query });
        } else {
            data = await Q.get(`/api/op_logs`, { query });
        }
        this.setState({ pagedResult: Pagination2.addItemIndex(data) });
    }

    goToPage(page) {
        const query = Object.assign({}, this.state.query, { page_no: page });
        this.refresh(query);
    }

    render() {
        return (
            <div>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th width="64">序号</th>
                            <th width="196">时间</th>
                            <th width="120">用户</th>
                            <th width="96">类型</th>
                            <th width="128">ID</th>
                            <th width="96">操作</th>
                            <th>摘要</th>
                        </tr>
                    </thead>
                    <tbody>
                        { this.state.pagedResult.results.map((opLog, index) =>
                            <OpLog index={index} opLog={opLog} key={index} />) }
                    </tbody>
                </table>
                <Pagination2
                    pagedResult={this.state.pagedResult}
                    goToPage={this.goToPage.bind(this)}
                />
            </div>
        );
    }
}

function OpLog({ opLog, index }) {
    return (
        <tr>
            <td>{index + 1}</td>
            <td>{new Date(opLog.ctime * 1000).toLocaleString()}</td>
            <td>{opLog.user ? opLog.user.name : ''}</td>
            <td>{opLog.obj_type}</td>
            <td className="code">
                <a href={`/${opLog.obj_type}/${opLog.obj_id}`} target='_blank'>
                    {opLog.obj_id}
                </a>
            </td>
            <td>{opLog.type}</td>
            <td>{opLog.obj_extra && opLog.obj_extra.digest}</td>
        </tr>
    );
}

export class ProfileOpLogsPage extends React.Component {
    componentDidMount() {
        setCurrentNav('历史操作', null, true);
    }

    render() {
        return (
            <div id="my-recent-op-logs">
                <OpLogs uid={Global.user._id} />
            </div>
        );
    }
}

export class UserOpLogsPage extends React.Component {
    componentDidMount() {
        setCurrentNav('历史操作', this.props.params.id, false);
    }

    render() {
        return (
            <div id="user-recent-op-logs">
                <OpLogs uid={this.props.params.id} />
            </div>
        );
    }
}

export function OpLogsPage() {
    return (
        <div id="recent-op-logs">
            <OpLogs />
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/user/oplogs.jsx